// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"a2430ba9","176":"1d8b5684","546":"6b72efc2","660":"d56ca971","718":"d394bc06","757":"711f3b3b","758":"6f00fdc2","760":"9bf610bf"}[chunkId] + ".chunk.js";
};